<template>
  <div class="sc-header rounded-top relative flex items-center p-4 h-16"
       :style="styles.wrapper"
  >
    <img v-if="themeConfig.header.logoOnly && headerLogoSrc"
         :src="headerLogoSrc"
         alt="company logo"
         height="38"
    />

    <img v-else-if="headerLogoSrc"
         :src="headerLogoSrc"
         class="rounded-full mr-2"
         height="38"
         width="38"
         alt="company logo rounded"
    />

    <span v-if="!themeConfig.header.logoOnly"
          :style="styles.title"
    >
      {{ langConfigDefaultWelcome }}
    </span>

    <div class="sc-header--close-button ml-auto self-center rounded cursor-pointer mr-2.5">
      <arrowDownIcon :style="styles.closeBtn"/>
    </div>
  </div>
</template>

<script>
import arrowDownIcon from '@/assets/images/icons/chat-widget/arrowDownIcon.vue'

export default {
  name: 'ChatHeader',

  components: {
    arrowDownIcon
  },

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    langConfig: {
      type: Object,
      required: true
    },
    headerLogoCache: {
      type: File
    }
  },

  computed: {
    headerLogoSrc() {
      const logo = this.headerLogoCache || this.themeConfig.header.logoUrl
      if (!logo) return null

      if (logo instanceof File) {
        return URL.createObjectURL(logo)
      }

      return logo
    },

    styles() {
      return {
        wrapper: {
          background: this.themeConfig.header.bg,
          color: this.themeConfig.header.text,
          fontFamily: this.themeConfig.font
        },
        title: {
          padding: this.themeConfig.header.padding,
          fontSize: this.themeConfig.header.fontSize
        },
        closeBtn: {
          color: this.themeConfig.header.closeBtn.color
        }
      }
    },

    langConfigDefaultWelcome() {
      return this.langConfig?.default?.welcome
    }
  }
}
</script>
